<template>
  <div>
    <el-card>
      <div slot="header">
        <div class="header-title">
          <h4>选择现有的模板（三选一）或者自定义模板</h4>
          <el-button
            :disabled="self"
            type="primary"
            @click="
              dialogVisible = true;
              isAdd = true;
            "
            >添加</el-button
          >
        </div>
      </div>
      <div class="stencil-body" v-if="stencilList.length > 0">
        <div class="item" v-for="item in stencilList" :key="item.name">
          <div class="title">
            <span>{{ item.name }}</span>
            <i
              v-show="item.selfModule"
              @click="
                dialogVisible = true;
                isAdd = false;
                stencilForm = item;
              "
              class="el-icon-edit"
            ></i>
          </div>
          <div class="post">
            <img v-if="item.url" :src="item.url" alt="" />
            <div v-else>海报</div>
          </div>
          <div class="btn" v-if="item.type != 2">
            <el-button
              v-if="!item.enable"
              @click="usedModule(item.id)"
              class="btn-active"
              type="primary"
              :plain="!item.enable"
              >使用模板</el-button
            >
            <el-button
              v-else
              class="btn-active"
              type="primary"
              :plain="!item.enable"
              >使用中</el-button
            >
            <el-button @click="toDetail(item.id)" type="text">预览</el-button>
          </div>
          <div class="btn" v-else>
            <el-button
              v-if="!item.enable"
              @click="usedModule(item.id)"
              type="primary"
              plain
              >使用自定义模板</el-button
            >
            <el-button
              v-else
              class="btn-active"
              type="primary"
              :plain="!item.enable"
              >使用中</el-button
            >
            <el-button @click="toDetail(item.id)" type="text">预览</el-button>
          </div>
        </div>
      </div>
      <div v-else>暂无可用模板，请点击右上角添加按钮进行添加</div>
      <el-pagination
        style="text-align: right"
        @current-change="handleCurrentChange"
        small
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加自定义模板' : '编辑模板'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="stencilForm"
        label-width="80px"
      >
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="stencilForm.name"></el-input>
        </el-form-item>
        <el-form-item label="海报">
          <el-upload
            class="avatar-uploader"
            :action="activeUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="stencilForm.url" :src="stencilForm.url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addStencilItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      stencilList: [],
      self: false,
      selfModule: false,
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      isAdd: true,
      stencilForm: {
        name: "",
        url: "",
        used: false,
        isDIY: false,
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        post: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },
      activeUrl: process.env.BASE_URL + "/system/uploadFile",
    };
  },
  created() {
    this.getAppList();
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/appEdit",
        query: {
          id,
        },
      });
    },
    addStencilItem() {
      if (this.isAdd) {
        const params = {
          name: this.stencilForm.name,
          url: this.stencilForm.post,
          type: 2
        };
        console.log(params);
        this.api.appConfigure.addAppSchoolPageTemplate(params).then((res) => {
          if (res.code == 200) {
            this.handleClose();
            this.$router.push({
              path: "/appEdit",
              query: {
                id: res.data,
              },
            });
          }
        });
      } else {
        this.updateModule();
      }
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    changeName(index, key, value) {
      console.log(2334);
      this.stencilList[index][key] = value;
    },
    usedModule(id) {
      this.api.appConfigure.useAppSchoolPageTemplate({ id }).then((res) => {
        if (res.code == 200) {
          this.getAppList();
        }
      });
    },
    updateModule() {
      const { id, name, url } = this.stencilForm;
      this.api.appConfigure
        .updateAppSchoolPageTemplate({ id, name, url })
        .then((res) => {
          if (res.code == 200) {
            this.getAppList();
          }
        });
    },
    getAppList() {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: 10,
      };
      this.api.appConfigure.appList(params).then((res) => {
        if (res.code == 200) {
          const { data } = res;
          this.stencilList = data.pageList.records;
          this.total = data.pageList.total;

          this.self = data.isPage;
          this.stencilList.forEach((el) => {
            this.$set(el, "changed", true);
            if (el.type == 2) this.$set(el, "selfModule", true);
            else this.$set(el, "selfModule", false);
            this.$set(el, "enable", el.enabled == 1 ? true : false);
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getAppList();
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, 44);
      this.stencilForm.url = res.data;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style lang="less" scoped>
.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
}
.stencil-body {
  padding: 0 30px;
  display: flex;
  // justify-content: space-around;
  .item {
    margin-right: 30px;
    .title {
      margin-bottom: 20px;
      text-align: center;
      span {
        font-size: 16px;
      }
      i {
        margin-left: 40px;
        color: #409eff;
        cursor: pointer;
      }
    }
    .post {
      width: 290px;
      height: 500px;
      margin-bottom: 20px;
      img,
      & > div {
        width: 100%;
        height: 100%;
      }
      & > div {
        line-height: 500px;
        text-align: center;
        background-color: #f2f2f2;
      }
    }
    .btn {
      text-align: center;
    }
  }
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.btn-active {
  & /deep/ .el-button--primary.is-plain:active {
    color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/miniApp/index.vue